'use strict';

/*
The downtime service returns this object
{
    "status": 200,
    "messages": [ ],
    "DowntimeList": [
        {
            "cntryCd": "US ",
            "id": 840,
            "downTimeStart": null,
            "downTimeEnd": null
        },
        {
            "cntryCd": "CA ",
            "id": 124,
            "downTimeStart": null,
            "downTimeEnd": null
        }
    ]
}*/
import $ from '@nuskin/nuskinjquery';
import {utilModule} from '../module.js';
import {RunConfigService, UrlService} from '@nuskin/ns-util'


utilModule.factory('nsDowntime', ['$http','$q', function($http, $q) {
    let THIRTY_MIN = 60 * 30 * 1000;
    let deferred = $q.defer();
    let downtime;
    let downtimeCookie = $.cookie('downtime');
    $http.defaults.headers.common['client_id'] = RunConfigService.getRunConfig().clientId;
    $http.defaults.headers.common['client_secret'] = RunConfigService.getRunConfig().clientSecret;
    if (downtimeCookie !== undefined) {
        downtime = JSON.parse(downtimeCookie);
    }

    let service = {
        getDowntime: function(locale) {
            // We need to call this service every time. We don't know when the downtime
            // value is changed in the Ecom admin tool.
            $http.get(`${UrlService.getAwsUrl()}/downtime/v2/${locale}`).then(function (response) {
                downtime = response.data.downtime;
                const message = response.data.messages.find((msg) => msg.code === 'ScheduledMaintenance');
                downtime.message = message ? message.message : '';

                if (downtime) {
                    $.cookie('downtime', JSON.stringify(downtime), {path:'/'});
                }
                deferred.resolve();
            });
            return deferred.promise;
        },
        downtime: function() {
            return downtime;
        },
        isGoingDownSoon: function() {
            let result = 0;
            if (this.isDown(THIRTY_MIN)) {
                let now = new Date().getTime();
                result = downtime.downTimeStart - now;
            }
            result = Math.ceil((result / 1000) / 60);
            return result;
        },
        isDown: function(offset) {    //Make sure you call getDowntime first and then in the promise call isDown
            let down = false;
            let now = new Date().getTime();
            if (offset) {
                now += offset;
            }
            if (downtime) {
                if (downtime.downTimeStart !== null) {
                    // We are down if current time is in between start time and end time.
                    if (downtime.downTimeEnd !== null) {
                        down = now >= downtime.downTimeStart && now < downtime.downTimeEnd;
                    }

                    // We are down if current time is after start time and there is no end time specified.
                    else {
                        down = now >= downtime.downTimeStart;
                    }
                }
            } else {
                console.log("Error: You need to call isDown when the getDowntime promise is resolved!");
            }
            return down;
        },
        getMessage: function() {
            return downtime && downtime.message;
        }
    };

    return service;
}]);